module.exports = __webpack_public_path__ + "static/promise-6fac9e75dfa3f0cd41d281fac0ec1551.jpg";